import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import GenericQuantityFormItemProvider
  from "../../_generic/quantity/GenericQuantityFormItemProvider";
import { CargoQuantity } from "../../../../../../domain/units/CargoQuantity";

const fieldName = "Total Loaded / Discharged";

const BillOfLadingQuantityFormItemProvider: FormItemProvider<CargoQuantity> = (props: FormItemProviderProps<CargoQuantity>) => (
  <GenericQuantityFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="CargoBillOfLadingQuantity"
  />
);

export default React.memo(BillOfLadingQuantityFormItemProvider);
